import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegisterUser } from '../../shared/models/register-user.model';
import { RegisterService } from '../../shared/services/register.service';
import { Question } from '../../shared/models/question.model';
import { Questionnaire } from '../../shared/models/questionnaire.model';

import swal from 'sweetalert2';
import { User } from '../../shared/models/user.model';

@Component({
  selector: 'app-register-user-question',
  templateUrl: './register-user-question.component.html',
  styleUrls: ['./register-user-question.component.css']
})
export class RegisterUserQuestionComponent implements OnInit {

  registerUser: RegisterUser

  questions: Question[];

  currentQuestion: Question;

  selectQuestionnaire: Questionnaire;

  numQuestion: number;

  correctAnswers: number;

  showSpinner: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _registerService: RegisterService
  ) { }

  ngOnInit() {

    this.numQuestion = 0;
    this.correctAnswers = 0;
    this.showSpinner = false;

    this.registerUser = JSON.parse(sessionStorage.getItem('registerUser'));

    if (this.registerUser === null || this.registerUser === undefined) {

      this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">No hay datos que mostrar</p>', 'warning', '100');

    } else {

      this._registerService.getCountAccess(this.registerUser.numContrato, this.registerUser.identificacion).subscribe(
        res => {
          if (res < 3 && res >= 0) {
            this.showSpinner = true;
            this._registerService.getQuestions(this.registerUser.identificacion).subscribe(
              res => {
                //console.log(res);
                this.questions = res;
                this.showSpinner = false;
                this.showCurrentQuestion();
              },
              err => {
                this.showSpinner = false;
                if(err.status === 500){ 
                  this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">La información no se encuentra disponible. por favor intenta mas tarde.</p>', 'warning', '100');
                }else{
                  this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">' + err.error.message + '</p>', 'warning', '100');
                }
              }
            );

          } else {
            /*Supera Intentos validos*/
            if (res >= 2) {
              this.registerUserOffice('REGISTRADO');

            } else {
              this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">La información no se encuentra disponible. por favor intenta mas tarde.</p>', 'warning', '100');

            }
          }

        },
        err => {
          this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">La información no se encuentra disponible. por favor intenta mas tarde.</p>', 'warning', '100');
        }
      );

    }

  }

  showCurrentQuestion() {
    this.currentQuestion = this.questions[this.numQuestion];
  }

  onSelectionChangeQuestionnaire(q: Questionnaire) {
    //console.log(q);
    this.selectQuestionnaire = q;
  }

  nextQuestion() {

    if (this.selectQuestionnaire === undefined || this.selectQuestionnaire === null) {
      swal({
        title: '',
        html: '<p style="font-size:14px">No ha seleccionado una opción</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.selectQuestionnaire.correct === 'si') {
      this.correctAnswers++;
    }

    this.numQuestion++;

    if (this.numQuestion < this.questions.length) {
      this.selectQuestionnaire = null;
      this.showCurrentQuestion();

    } else {

      if (this.correctAnswers === this.questions.length) {
        //respuestas correctas
        this.registerUserOffice('');

      } else {

        this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">Algunas de las preguntas no fueron respondidas acertadamente, por favor intenta nuevamente.</p>', 'warning', '100');

      }


    }


    //console.log(this.correctAnswers + ' correcta(s) de ' + this.questions.length);

  }

  messageRegisterUser(message: string, srcImage: string, widthImage: string) {

    sessionStorage.removeItem('registerUser');//borramos datos de usuario que se registro

    sessionStorage.removeItem('messageRegisterUser');
    sessionStorage.setItem('messageRegisterUser', message);

    sessionStorage.removeItem('srcImageRegisterUser');
    sessionStorage.setItem('srcImageRegisterUser', srcImage);

    sessionStorage.removeItem('widthImageRegisterUser');
    sessionStorage.setItem('widthImageRegisterUser', widthImage);

    this._router.navigate(['/auth/register/user/message']);

  }

  registerUserOffice(statusRegister: string) {

    this._registerService.postRegisterUser({
      email: this.registerUser.email, documentId: this.registerUser.identificacion,
      residentialPhone: this.registerUser.telefono, contractNumber: this.registerUser.numContrato, digit: (this.registerUser.numBeneficiario !== '' ? parseInt(this.registerUser.numBeneficiario) : 0),
      news: '' + this.registerUser.aceptaRecibirInfo, webRegistrationStatus: statusRegister
    }).subscribe(
      res => {

        this.messageRegisterUser(res.message, res.type, '50');

      },
      err => {
        this.messageRegisterUser('<b>Lo Sentimos:</b><br/><br/><p align="justify">La información no se encuentra disponible. por favor intenta mas tarde.</p>', 'warning', '100');
      }
      );


  }

  cancelRegister() {

    swal({
      width: 600,
      padding: 30,
      showCloseButton: true,
      type: 'question',
      html: '<p style="font-size: 14px">Desea cancelar el registro al portal de usuarios de MedPlus Medicina Prepagada</p>',
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-success btn-confirm-modal',
      confirmButtonText: 'Confirmar',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-warning',
      cancelButtonText: 'Volver',
      buttonsStyling: false,
      focusConfirm: false
    }).then((result) => {
      if (result.value) {
        sessionStorage.clear();
        this._router.navigate(['/auth/register']);
      }
    })


  }


}



// WEBPACK FOOTER //
// /app/src/app/auth/register-user-question/register-user-question.component.ts